import React from 'react'

const Divider = () => {
  return (
    <div className='divider d-none d-md-flex' >
      <div className="box1"></div>
      <div className="box-gap"></div>
      <div className="box2"></div>
    </div>
  )
}

export default Divider
